import { httpClient } from "utils/infrastructure/httpClient"

export interface ErrorResponse {
    error: string
    fields: []
}

export interface FetchByCode {
    verification_code?: string
    verification_token: string
    resend_timeout: number
}

export const fetchAuthByCode = (email: string) => {
    return httpClient.post<FetchByCode & ErrorResponse>(
        "client/auth2/verification-code/send/email/login",
        {
            email,
        }
    )
}

export const fetchRegisterByCode = (email: string, name: string) => {
    return httpClient.post<FetchByCode & ErrorResponse>(
        "client/auth2/verification-code/send/email/register",
        {
            email,
            name,
        }
    )
}

export const fetchVerifyByCode = ({
    code,
    token,
    email,
}: {
    code: string
    token: string
    email: string
}) => {
    return httpClient.post("client/auth2/verification-code/verify/email", {
        verification_code: code,
        verification_token: token,
        email,
    })
}
